module.exports = __webpack_public_path__ + "static/garage-1-d6aba057922f12d14df4c19cdd7c9f32.jpg";